/* eslint-disable @next/next/no-img-element */
//components
import {
  Breadcrumb,
  BreadcrumbLink,
  Grad,
} from '@/containers-ai/SectionHeading';
import { PillLink, GhostLink } from '@/containers-ai/Buttons';

//styles
import {
  HeroSection,
  HeroBg,
  HeroVisual,
  HeroBgFade,
  HeroInner,
  HeroTitle,
  HeroDescription,
  HeroMetric,
  HeroMetricValue,
  HeroMetricText,
  HeroMetricLabel,
  HeroMetricSource,
  HeroCta,
} from './Hero.styles';

export function Hero({
  slug,
  title,
  description,
  metric,
  metricLabel,
  metricSource,
}) {
  return (
    <HeroSection id="top">
      <HeroBg>
        <HeroVisual
          src={`/images/ai/agents/${slug}/hero-visual.webp`}
          srcSet={`/images/ai/agents/${slug}/hero-visual-sm.webp 640w, /images/ai/agents/${slug}/hero-visual-md.webp 960w, /images/ai/agents/${slug}/hero-visual.webp 1920w`}
          sizes="100vw"
          fetchpriority="high"
          alt=""
          aria-hidden="true"
        />
        <HeroBgFade />
      </HeroBg>
      <HeroInner>
        <Breadcrumb>
          <BreadcrumbLink href="/">LOADSMART</BreadcrumbLink>
          <span>/</span>
          <BreadcrumbLink href="/ai/">LOADSMART AI</BreadcrumbLink>
          <span>/</span>
          <b>{title.toUpperCase()}</b>
        </Breadcrumb>
        <HeroTitle>
          Meet the Agent: <br /> <Grad>{title}</Grad>
        </HeroTitle>
        <HeroDescription>{description}</HeroDescription>
        <HeroMetric>
          <HeroMetricValue>
            <Grad>{metric}</Grad>
          </HeroMetricValue>
          <HeroMetricText>
            <HeroMetricLabel>{metricLabel}</HeroMetricLabel>
            {metricSource && (
              <HeroMetricSource>{metricSource}</HeroMetricSource>
            )}
          </HeroMetricText>
        </HeroMetric>
        <HeroCta>
          <PillLink href="#watch-it-run" className="qlf-btn-1">
            See it run on your freight
          </PillLink>
          <GhostLink href="#how-it-works">How it works</GhostLink>
        </HeroCta>
      </HeroInner>
    </HeroSection>
  );
}
